import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/api';
import './HRM.css';

const HRM = ({ activeTab: propActiveTab }) => {
  const [activeTab, setActiveTab] = useState('hrm');
  useEffect(() => {
    if (propActiveTab) {
      const m = {
        hrm: 'hrm', hrm_dashboard: 'hrm',
        hrm_leave_type: 'leave_type', hrm_leave: 'leave',
        hrm_attendance: 'attendance', hrm_payroll: 'payroll',
        hrm_holiday: 'holiday', hrm_departments: 'departments',
        hrm_designations: 'designations', hrm_sales_target: 'sales_target',
        hrm_settings: 'settings'
      };
      if (m[propActiveTab]) setActiveTab(m[propActiveTab]);
    }
  }, [propActiveTab]);

  const [loading, setLoading] = useState(false);
  const [dash, setDash] = useState({});
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [payrolls, setPayrolls] = useState([]);
  const [payrollGroups, setPayrollGroups] = useState([]);
  const [salesTargets, setSalesTargets] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [settings, setSettings] = useState({});

  const [mLT, setMLT] = useState(false); const [mL, setML] = useState(false); const [mH, setMH] = useState(false); const [mA, setMA] = useState(false); const [mP, setMP] = useState(false); const [mDept, setMDept] = useState(false); const [mDesig, setMDesig] = useState(false);
  const [eLT, setELT] = useState(null); const [eH, setEH] = useState(null); const [eP, setEP] = useState(null); const [viewP, setViewP] = useState(null); const [eDept, setEDept] = useState(null); const [eDesig, setEDesig] = useState(null);
  const [fLT, setFLT] = useState({ leave_type: '', max_leave_count: '', leave_count_interval: 'none' });
  const [fL, setFL] = useState({ user_id: '', essentials_leave_type_id: '', start_date: '', end_date: '', reason: '', ref_no: '' });
  const [fH, setFH] = useState({ name: '', start_date: '', end_date: '', location_id: '', note: '' });
  const [fP, setFP] = useState({ name: '', location_id: '', gross_total: '', status: 'final' });
  const [fDept, setFDept] = useState({ name: '', department_id: '', description: '' });
  const [fDesig, setFDesig] = useState({ name: '', description: '' });
  const [fSet, setFSet] = useState({});
  const [attRows, setAttRows] = useState([]);
  const [selEmp, setSelEmp] = useState('');
  const [shifts, setShifts] = useState([]);

  const [sLT, setSLT] = useState(''); const [sL, setSL] = useState(''); const [sA, setSA] = useState(''); const [sH, setSH] = useState(''); const [sP, setSP] = useState(''); const [sD, setSD] = useState(''); const [sDe, setSDe] = useState(''); const [sST, setSST] = useState('');
  const [fLVis, setFLVis] = useState(false); const [fLSt, setFLSt] = useState(''); const [fLU, setFLU] = useState(''); const [fLTy, setFLTy] = useState('');
  const [subA, setSubA] = useState('all'); const [subP, setSubP] = useState('all_payrolls'); const [subS, setSubS] = useState('leave');

  useEffect(() => { loadU(); loadLoc(); loadShifts(); }, []);
  useEffect(() => {
    if (activeTab === 'hrm') loadDash();
    if (activeTab === 'leave_type') loadLT();
    if (activeTab === 'leave') loadLeaves();
    if (activeTab === 'attendance') loadAtt();
    if (activeTab === 'payroll') { loadPay(); loadPG(); }
    if (activeTab === 'holiday') loadHol();
    if (activeTab === 'departments') loadDept();
    if (activeTab === 'designations') loadDesig();
    if (activeTab === 'sales_target') loadST();
    if (activeTab === 'settings') loadSet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const loadDash = async () => { setLoading(true); try { const r = await apiService.getHrmDashboard(); setDash(r?.data || {}); } catch(e){} setLoading(false); };
  const loadLT = async () => { setLoading(true); try { const r = await apiService.getHrmLeaveTypes(); setLeaveTypes(r?.data || []); } catch(e){} setLoading(false); };
  const loadLeaves = async () => { setLoading(true); try { const p={}; if(fLSt) p.status=fLSt; if(fLU) p.user_id=fLU; if(fLTy) p.leave_type=fLTy; const r=await apiService.getHrmLeaves(p); setLeaves(r?.data || []); } catch(e){} setLoading(false); };
  const loadAtt = async () => { setLoading(true); try { const r=await apiService.getHrmAttendance(); setAttendance(r?.data || []); } catch(e){} setLoading(false); };
  const loadShifts = async () => { try { const r=await apiService.getHrmShifts(); setShifts(r?.data || []); } catch(e){} };
  const loadHol = async () => { setLoading(true); try { const r=await apiService.getHrmHolidays(); setHolidays(r?.data || []); } catch(e){} setLoading(false); };
  const loadPay = async () => { setLoading(true); try { const r=await apiService.getHrmPayrolls(); setPayrolls(r?.data || []); } catch(e){} setLoading(false); };
  const loadPG = async () => { try { const r=await apiService.getHrmPayrollGroups(); setPayrollGroups(r?.data || []); } catch(e){} };
  const loadST = async () => { setLoading(true); try { const r=await apiService.getHrmSalesTargets(); setSalesTargets(r?.data || []); } catch(e){} setLoading(false); };
  const loadDept = async () => { setLoading(true); try { const r=await apiService.getHrmDepartments(); setDepartments(r?.data || []); } catch(e){} setLoading(false); };
  const loadDesig = async () => { setLoading(true); try { const r=await apiService.getHrmDesignations(); setDesignations(r?.data || []); } catch(e){} setLoading(false); };
  const loadU = async () => { try { const r=await apiService.getHrmUsers(); setUsers(r?.data || []); } catch(e){} };
  const loadLoc = async () => { try { const r=await apiService.getHrmLocations(); setLocations(r?.data || []); } catch(e){} };
  const loadSet = async () => { setLoading(true); try { const r = await apiService.getHrmSettings(); setSettings(r?.data || {}); setFSet(r?.data || {}); } catch(e){} setLoading(false); };
  const svSet = async () => { try { await apiService.updateHrmSettings(fSet); toast.success('HRM settings updated successfully!'); loadSet(); } catch(e){ toast.error(e.message || 'Failed to update settings'); } };

  const svLT = async () => { try { if(eLT) await apiService.updateHrmLeaveType(eLT, fLT); else await apiService.createHrmLeaveType(fLT); setMLT(false); setFLT({ leave_type:'', max_leave_count:'', leave_count_interval:'none' }); setELT(null); toast.success(eLT ? 'Leave type updated successfully!' : 'Leave type added successfully!'); loadLT(); } catch(e){ toast.error(e.message || 'Error saving leave type'); } };
  const delLT = async (id) => { if(!window.confirm('Delete this leave type?')) return; try { await apiService.deleteHrmLeaveType(id); toast.success('Leave type deleted successfully!'); loadLT(); } catch(e){ toast.error(e.message || 'Error deleting leave type'); } };
  const svL = async () => { try { await apiService.createHrmLeave(fL); setML(false); setFL({ user_id:'', essentials_leave_type_id:'', start_date:'', end_date:'', reason:'', ref_no:'' }); toast.success('Leave request added successfully!'); loadLeaves(); } catch(e){ toast.error(e.message || 'Error creating leave'); } };
  const updLSt = async (id, st) => { try { await apiService.updateHrmLeaveStatus(id, { status: st, status_note: '' }); toast.success('Leave status updated successfully!'); loadLeaves(); } catch(e){ toast.error(e.message || 'Error updating leave status'); } };
  const svH = async () => { try { if(eH) await apiService.updateHrmHoliday(eH, fH); else await apiService.createHrmHoliday(fH); setMH(false); setFH({ name:'', start_date:'', end_date:'', location_id:'', note:'' }); setEH(null); toast.success(eH ? 'Holiday updated successfully!' : 'Holiday added successfully!'); loadHol(); } catch(e){ toast.error(e.message || 'Error saving holiday'); } };
  const delH = async (id) => { if(!window.confirm('Delete this holiday?')) return; try { await apiService.deleteHrmHoliday(id); toast.success('Holiday deleted successfully!'); loadHol(); } catch(e){ toast.error(e.message || 'Error deleting holiday'); } };
  const svP = async () => { try { if(eP) await apiService.updateHrmPayroll(eP, fP); else await apiService.createHrmPayroll(fP); setMP(false); setEP(null); setFP({ name:'', location_id:'', gross_total:'', status:'final' }); toast.success(eP ? 'Payroll group updated successfully!' : 'Payroll group created successfully!'); loadPay(); loadPG(); } catch(e){ toast.error(e.message || 'Error saving payroll'); } };
  const svDept = async () => { try { if(eDept) await apiService.updateHrmDepartment(eDept, fDept); else await apiService.createHrmDepartment(fDept); setMDept(false); setEDept(null); setFDept({ name:'', department_id:'', description:'' }); toast.success(eDept ? 'Department updated successfully!' : 'Department added successfully!'); loadDept(); } catch(e){ toast.error(e.message || 'Error saving department'); } };
  const delDept = async (id) => { if(!window.confirm('Delete this department?')) return; try { await apiService.deleteHrmDepartment(id); toast.success('Department deleted successfully!'); loadDept(); } catch(e){ toast.error(e.message || 'Error deleting department'); } };
  const svDesig = async () => { try { if(eDesig) await apiService.updateHrmDesignation(eDesig, fDesig); else await apiService.createHrmDesignation(fDesig); setMDesig(false); setEDesig(null); setFDesig({ name:'', description:'' }); toast.success(eDesig ? 'Designation updated successfully!' : 'Designation added successfully!'); loadDesig(); } catch(e){ toast.error(e.message || 'Error saving designation'); } };
  const delDesig = async (id) => { if(!window.confirm('Delete this designation?')) return; try { await apiService.deleteHrmDesignation(id); toast.success('Designation deleted successfully!'); loadDesig(); } catch(e){ toast.error(e.message || 'Error deleting designation'); } };

  const addEmpRow = (userId) => {
    if (!userId) return;
    const u = users.find(x => String(x.id) === String(userId));
    if (!u) return;
    if (attRows.some(x => String(x.user_id) === String(userId))) return;
    const nowIso = new Date().toISOString().slice(0, 16);
    setAttRows(prev => [...prev, {
      user_id: u.id,
      user_name: u.name,
      clock_in_time: nowIso,
      clock_out_time: '',
      essentials_shift_id: '',
      ip_address: '',
      clock_in_note: '',
      clock_out_note: ''
    }]);
    setSelEmp('');
  };

  const rmEmpRow = (userId) => {
    setAttRows(prev => prev.filter(x => String(x.user_id) !== String(userId)));
  };

  const updateEmpRow = (userId, field, val) => {
    setAttRows(prev => prev.map(x => String(x.user_id) === String(userId) ? { ...x, [field]: val } : x));
  };

  const svAtt = async () => {
    if (attRows.length === 0) { toast.warning('Please select at least one employee'); return; }
    try {
      const payload = {};
      attRows.forEach(r => {
        payload[r.user_id] = {
          user_id: r.user_id,
          clock_in_time: r.clock_in_time,
          clock_out_time: r.clock_out_time,
          essentials_shift_id: r.essentials_shift_id,
          ip_address: r.ip_address,
          clock_in_note: r.clock_in_note,
          clock_out_note: r.clock_out_note
        };
      });
      await apiService.createHrmAttendance({ attendance: payload });
      setMA(false);
      setAttRows([]);
      toast.success('Attendance saved successfully!');
      loadAtt();
    } catch(e) {
      toast.error(e.message || 'Failed to save attendance');
    }
  };

  const delAtt = async (id) => { if(!window.confirm('Delete attendance entry?')) return; try { await apiService.deleteHrmAttendance(id); toast.success('Attendance record deleted successfully!'); loadAtt(); } catch(e){ toast.error(e.message || 'Failed to delete attendance'); } };

  const badge = (status) => {
    const m = { pending: ['#fef3c7','#92400e'], approved: ['#dcfce7','#166534'], cancelled: ['#fee2e2','#991b1b'] };
    const [bg, co] = m[status] || ['#f3f4f6','#374151'];
    return <span className="mfg-badge" style={{ background: bg, color: co }}>{status}</span>;
  };

  const tabs = [
    { k: 'hrm', l: 'Dashboard Overview', i: 'fas fa-chart-line' },
    { k: 'leave_type', l: 'Leave Types', i: 'fas fa-list-alt' },
    { k: 'leave', l: 'Leave Requests', i: 'fas fa-calendar-alt' },
    { k: 'attendance', l: 'Attendance Logs', i: 'fas fa-clock' },
    { k: 'payroll', l: 'Payroll Run', i: 'fas fa-money-bill-wave' },
    { k: 'holiday', l: 'Holidays', i: 'fas fa-umbrella-beach' },
    { k: 'departments', l: 'Departments', i: 'fas fa-building' },
    { k: 'designations', l: 'Designations', i: 'fas fa-id-badge' },
    { k: 'sales_target', l: 'Sales Targets', i: 'fas fa-bullseye' },
    { k: 'settings', l: 'HRM Settings', i: 'fas fa-sliders' },
  ];

  const renderStatsHeader = () => (
    <div className="mfg-stats-grid">
      <div className="mfg-stat-card">
        <div className="mfg-stat-icon-wrap" style={{ background: 'rgba(79, 70, 229, 0.1)', color: '#4f46e5' }}>
          <i className="fas fa-users" />
        </div>
        <div className="mfg-stat-info">
          <div className="mfg-stat-label">Total Employees</div>
          <div className="mfg-stat-value">{dash.total_users ?? users.length ?? 0}</div>
          <div className="mfg-stat-subtext">Active staff profiles</div>
        </div>
      </div>

      <div className="mfg-stat-card">
        <div className="mfg-stat-icon-wrap" style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b' }}>
          <i className="fas fa-clock" />
        </div>
        <div className="mfg-stat-info">
          <div className="mfg-stat-label">Today's Attendance</div>
          <div className="mfg-stat-value" style={{ fontSize: '1.15rem' }}>{dash.today_attendance ? 'Clocked In' : 'Not Clocked In'}</div>
          <div className="mfg-stat-subtext">Real-time status</div>
        </div>
      </div>

      <div className="mfg-stat-card">
        <div className="mfg-stat-icon-wrap" style={{ background: 'rgba(16, 185, 129, 0.1)', color: '#10b981' }}>
          <i className="fas fa-calendar-alt" />
        </div>
        <div className="mfg-stat-info">
          <div className="mfg-stat-label">My Leaves</div>
          <div className="mfg-stat-value">{dash.my_leaves ?? 0}</div>
          <div className="mfg-stat-subtext">Allocated leave balance</div>
        </div>
      </div>

      <div className="mfg-stat-card">
        <div className="mfg-stat-icon-wrap" style={{ background: 'rgba(139, 92, 246, 0.1)', color: '#8b5cf6' }}>
          <i className="fas fa-building" />
        </div>
        <div className="mfg-stat-info">
          <div className="mfg-stat-label">Departments</div>
          <div className="mfg-stat-value">{departments.length || (dash.total_leave_types ?? 0)}</div>
          <div className="mfg-stat-subtext">Configured units</div>
        </div>
      </div>
    </div>
  );

  const Table = ({ h, rows, loading, emptyTitle = "No data available in table", onAdd }) => (
    <div className="mfg-table-wrap">
      <table className="mfg-table">
        <thead>
          <tr>{h.map((x, i) => <th key={i}>{x}</th>)}</tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={h.length} style={{ textAlign: 'center', padding: '3rem' }}><i className="fas fa-circle-notch fa-spin fa-2x" style={{ color: '#4f46e5' }} /></td></tr>
          ) : !rows.length ? (
            <tr>
              <td colSpan={h.length}>
                <div className="mfg-empty-state">
                  <div className="mfg-empty-icon-box">
                    <i className="fas fa-inbox" />
                  </div>
                  <div className="mfg-empty-title">{emptyTitle}</div>
                  <div className="mfg-empty-desc">There are currently no records found for this section. Click below to add a new entry.</div>
                  {onAdd && (
                    <button className="mfg-btn mfg-btn-primary" onClick={onAdd}>
                      <i className="fas fa-plus" /> Add New Record
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            rows.map((row, i) => React.cloneElement(row))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="mfg-page">
      {/* Top Banner Header */}
      <div className="mfg-page-header">
        <div className="mfg-page-header-title-wrap">
          <div className="mfg-page-icon">
            <i className="fas fa-users-cog" />
          </div>
          <div>
            <h1>Human Resource Management</h1>
            <div className="mfg-page-header-subtitle">Manage employee leaves, attendance tracking, payroll processing, and organization structure</div>
          </div>
        </div>
      </div>

      {/* Top Stats Overview Grid */}
      {renderStatsHeader()}

      {/* Top Nav Tabs Bar */}
      <div className="mfg-tabs-nav">
        {tabs.map(t => (
          <button
            key={t.k}
            className={`mfg-tab-btn ${activeTab === t.k ? 'active' : ''}`}
            onClick={() => setActiveTab(t.k)}
          >
            <i className={t.i} />
            {t.l}
          </button>
        ))}
      </div>

      {/* Tab Content Cards */}
      {activeTab === 'hrm' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-chart-line" style={{ color: '#4f46e5' }} /> HRM Dashboard Summary
          </div>
          <div className="mfg-stats-grid" style={{ marginBottom: 0 }}>
            {[
              { t: 'My Leaves', v: dash.my_leaves ?? 0, icon: 'fas fa-calendar-alt', color: 'rgba(79,70,229,0.1)', iconColor: '#4f46e5' },
              { t: 'My Sales Targets', v: dash.sales_target?.target_amount ?? 0, icon: 'fas fa-bullseye', color: 'rgba(16,185,129,0.1)', iconColor: '#10b981' },
              { t: 'Today\'s Attendance', v: dash.today_attendance ? 'Clocked In' : 'Not Clocked In', icon: 'fas fa-clock', color: 'rgba(245,158,11,0.1)', iconColor: '#f59e0b' },
              ...(dash.is_admin ? [
                { t: 'Total Users', v: dash.total_users ?? 0, icon: 'fas fa-users', color: 'rgba(236,72,153,0.1)', iconColor: '#ec4899' },
                { t: 'Leave Types', v: dash.total_leave_types ?? 0, icon: 'fas fa-list-alt', color: 'rgba(59,130,246,0.1)', iconColor: '#3b82f6' },
                { t: 'Holidays', v: dash.total_holidays ?? 0, icon: 'fas fa-umbrella-beach', color: 'rgba(139,92,246,0.1)', iconColor: '#8b5cf6' },
              ] : [])
            ].map((x, i) => (
              <div key={i} className="mfg-stat-card">
                <div className="mfg-stat-icon-wrap" style={{ background: x.color, color: x.iconColor }}>
                  <i className={x.icon} />
                </div>
                <div className="mfg-stat-info">
                  <div className="mfg-stat-label">{x.t}</div>
                  <div className="mfg-stat-value">{x.v}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'leave_type' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-list-alt" style={{ color: '#4f46e5' }} /> Leave Types Catalog
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search leave types..." value={sLT} onChange={e => setSLT(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => { setELT(null); setFLT({ leave_type:'', max_leave_count:'', leave_count_interval:'none' }); setMLT(true); }}>
                <i className="fas fa-plus" /> Add Leave Type
              </button>
            </div>
          </div>
          <Table
            h={['Leave Type', 'Max Leave Count', 'Leave Count Interval', 'Actions']}
            rows={leaveTypes.filter(x => !sLT || x.leave_type?.toLowerCase().includes(sLT.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.leave_type}</td>
                <td><span className="mfg-badge mfg-badge-primary">{x.max_leave_count}</span></td>
                <td>{x.leave_count_interval}</td>
                <td>
                  <div className="mfg-actions">
                    <button className="mfg-action-btn edit" onClick={() => { setELT(x.id); setFLT({ leave_type: x.leave_type, max_leave_count: x.max_leave_count, leave_count_interval: x.leave_count_interval }); setMLT(true); }} title="Edit"><i className="fas fa-pen" /></button>
                    <button className="mfg-action-btn delete" onClick={() => delLT(x.id)} title="Delete"><i className="fas fa-trash-alt" /></button>
                  </div>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Leave Types Configured"
            onAdd={() => { setELT(null); setFLT({ leave_type:'', max_leave_count:'', leave_count_interval:'none' }); setMLT(true); }}
          />
        </div>
      )}

      {activeTab === 'leave' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-calendar-alt" style={{ color: '#4f46e5' }} /> Leave Requests
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
              <button className="mfg-btn" onClick={() => setFLVis(!fLVis)}>
                <i className="fas fa-filter" /> Filters
              </button>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search leave requests..." value={sL} onChange={e => setSL(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => setML(true)}>
                <i className="fas fa-plus" /> Request Leave
              </button>
            </div>
          </div>

          {fLVis && (
            <div className="mfg-filter-card">
              <div className="mfg-filters">
                <div className="mfg-filter-group">
                  <label>Employee</label>
                  <select className="mfg-select" value={fLU} onChange={e => setFLU(e.target.value)}>
                    <option value="">All Employees</option>
                    {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                  </select>
                </div>
                <div className="mfg-filter-group">
                  <label>Status</label>
                  <select className="mfg-select" value={fLSt} onChange={e => setFLSt(e.target.value)}>
                    <option value="">All Statuses</option>
                    <option value="pending">Pending</option>
                    <option value="approved">Approved</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <div className="mfg-filter-group">
                  <label>Leave Type</label>
                  <select className="mfg-select" value={fLTy} onChange={e => setFLTy(e.target.value)}>
                    <option value="">All Leave Types</option>
                    {leaveTypes.map(lt => <option key={lt.id} value={lt.id}>{lt.leave_type}</option>)}
                  </select>
                </div>
              </div>
            </div>
          )}

          <Table
            h={['Ref No', 'Leave Type', 'Employee', 'Date Range', 'Reason', 'Status', 'Actions']}
            rows={leaves.filter(x => !sL || (x.user_name||'').toLowerCase().includes(sL.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600, color: '#4f46e5' }}>{x.ref_no}</td>
                <td><span className="mfg-badge mfg-badge-primary">{x.leave_type}</span></td>
                <td style={{ fontWeight: 600 }}>{x.user_name}</td>
                <td>{x.start_date} - {x.end_date}</td>
                <td>{x.reason}</td>
                <td>{badge(x.status)}</td>
                <td>
                  {x.status === 'pending' && (
                    <div className="mfg-actions">
                      <button className="mfg-btn mfg-btn-sm mfg-btn-success" onClick={() => updLSt(x.id, 'approved')}><i className="fas fa-check" /> Approve</button>
                      <button className="mfg-btn mfg-btn-sm" style={{ background: '#ef4444', color: '#fff' }} onClick={() => updLSt(x.id, 'cancelled')}><i className="fas fa-times" /> Cancel</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Leave Requests Found"
            onAdd={() => setML(true)}
          />
        </div>
      )}

      {activeTab === 'attendance' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-clock" style={{ color: '#4f46e5' }} /> Attendance Tracking
          </div>
          <div className="mfg-sub-tabs">
            {[{ k:'all', l:'All Attendance' }, { k:'shift', l:'By Shift' }, { k:'date', l:'By Date' }, { k:'import', l:'Import' }].map(t => (
              <button key={t.k} className={`mfg-sub-tab ${subA === t.k ? 'active' : ''}`} onClick={() => setSubA(t.k)}>{t.l}</button>
            ))}
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search attendance..." value={sA} onChange={e => setSA(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => { setAttRows([]); setSelEmp(''); setMA(true); loadShifts(); }}>
                <i className="fas fa-plus" /> Add Attendance
              </button>
            </div>
          </div>
          <Table
            h={['Employee Name', 'Shift', 'Clock In Time', 'Clock Out Time', 'Holiday Status', 'Actions']}
            rows={attendance.filter(x => !sA || (x.user_name||'').toLowerCase().includes(sA.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.user_name}</td>
                <td>{x.shift_name||'-'}</td>
                <td>{x.clock_in_time}</td>
                <td>{x.clock_out_time||'-'}</td>
                <td>-</td>
                <td>
                  <div className="mfg-actions">
                    <button className="mfg-action-btn delete" onClick={() => delAtt(x.id)} title="Delete"><i className="fas fa-trash-alt" /></button>
                  </div>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Attendance Logs Found"
            onAdd={() => { setAttRows([]); setSelEmp(''); setMA(true); loadShifts(); }}
          />
        </div>
      )}

      {activeTab === 'payroll' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-money-bill-wave" style={{ color: '#4f46e5' }} /> Payroll Management
          </div>
          <div className="mfg-sub-tabs">
            {[{ k:'all_payrolls', l:'All Payrolls' }, { k:'payroll_groups', l:'Payroll Groups' }, { k:'pay_components', l:'Pay Components' }].map(t => (
              <button key={t.k} className={`mfg-sub-tab ${subP === t.k ? 'active' : ''}`} onClick={() => setSubP(t.k)}>{t.l}</button>
            ))}
          </div>

          {subP === 'all_payrolls' && (
            <>
              <div className="mfg-toolbar">
                <div className="mfg-toolbar-left">
                  <div className="mfg-entries-group">
                    <span>Show</span>
                    <select><option>25</option></select>
                    <span>entries</span>
                  </div>
                </div>
                <div className="mfg-toolbar-right">
                  <div className="mfg-search-box">
                    <i className="fas fa-search mfg-search-icon" />
                    <input type="text" className="mfg-search" placeholder="Search payrolls..." value={sP} onChange={e => setSP(e.target.value)} />
                  </div>
                  <button className="mfg-btn mfg-btn-primary" onClick={() => { setEP(null); setFP({ name: '', location_id: '', gross_total: '', status: 'final' }); setMP(true); }}>
                    <i className="fas fa-plus" /> Add Payroll Run
                  </button>
                </div>
              </div>
              <Table
                h={['Payroll Name', 'Added By', 'Location', 'Gross Total', 'Payment Status', 'Status', 'Actions']}
                rows={payrolls.filter(x => !sP || (x.name||x.added_by||'').toLowerCase().includes(sP.toLowerCase())).map(x => (
                  <tr key={x.id}>
                    <td style={{ fontWeight: 600 }}>{x.name||'-'}</td>
                    <td>{x.added_by||'-'}</td>
                    <td>{x.location_name||'-'}</td>
                    <td style={{ fontWeight: 700, color: '#10b981' }}>{x.gross_total||'0.00'}</td>
                    <td>{badge(x.payment_status||'due')}</td>
                    <td>{badge(x.status||'pending')}</td>
                    <td>
                      <div className="mfg-actions">
                        <button className="mfg-action-btn view" onClick={() => setViewP(x)} title="View"><i className="fas fa-eye" /></button>
                        <button className="mfg-action-btn edit" onClick={() => { setEP(x.id); setFP({ name: x.name||'', location_id: x.location_id||'', gross_total: x.gross_total||'', status: x.status||'final' }); setMP(true); }} title="Edit"><i className="fas fa-pen" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
                loading={loading}
                emptyTitle="No Payroll Records Created"
                onAdd={() => { setEP(null); setFP({ name: '', location_id: '', gross_total: '', status: 'final' }); setMP(true); }}
              />
            </>
          )}

          {subP === 'payroll_groups' && (
            <>
              <div className="mfg-toolbar">
                <div className="mfg-toolbar-left" />
                <div className="mfg-toolbar-right">
                  <button className="mfg-btn mfg-btn-primary" onClick={() => { setEP(null); setFP({ name: '', location_id: '', gross_total: '', status: 'final' }); setMP(true); }}>
                    <i className="fas fa-plus" /> Add Group
                  </button>
                </div>
              </div>
              <Table
                h={['Group Name', 'Actions']}
                rows={payrollGroups.map(g => (
                  <tr key={g.id}>
                    <td style={{ fontWeight: 600 }}>{g.name}</td>
                    <td>
                      <div className="mfg-actions">
                        <button className="mfg-action-btn edit" onClick={() => { setEP(g.id); setFP({ name: g.name||'', location_id: g.location_id||'', gross_total: g.gross_total||'', status: g.status||'final' }); setMP(true); }}><i className="fas fa-pen" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
                loading={false}
                emptyTitle="No Payroll Groups"
                onAdd={() => { setEP(null); setFP({ name: '', location_id: '', gross_total: '', status: 'final' }); setMP(true); }}
              />
            </>
          )}

          {subP === 'pay_components' && (
            <div className="mfg-empty-state">
              <div className="mfg-empty-icon-box"><i className="fas fa-cog" /></div>
              <div className="mfg-empty-title">Pay Components</div>
              <div className="mfg-empty-desc">Pay Components setup and salary structure rules configuration coming soon.</div>
            </div>
          )}
        </div>
      )}

      {activeTab === 'holiday' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-umbrella-beach" style={{ color: '#4f46e5' }} /> Company Holidays
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search holidays..." value={sH} onChange={e => setSH(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => { setEH(null); setFH({ name:'', start_date:'', end_date:'', location_id:'', note:'' }); setMH(true); }}>
                <i className="fas fa-plus" /> Add Holiday
              </button>
            </div>
          </div>
          <Table
            h={['Holiday Name', 'Date Range', 'Location', 'Note', 'Actions']}
            rows={holidays.filter(x => !sH || (x.name||'').toLowerCase().includes(sH.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.name}</td>
                <td>{x.start_date}{x.end_date && x.end_date !== x.start_date ? ` - ${x.end_date}` : ''}</td>
                <td>{x.location_name||'All locations'}</td>
                <td>{x.note||'-'}</td>
                <td>
                  <div className="mfg-actions">
                    <button className="mfg-action-btn edit" onClick={() => { setEH(x.id); setFH({ name: x.name, start_date: x.start_date, end_date: x.end_date, location_id: x.location_id||'', note: x.note||'' }); setMH(true); }}><i className="fas fa-pen" /></button>
                    <button className="mfg-action-btn delete" onClick={() => delH(x.id)}><i className="fas fa-trash-alt" /></button>
                  </div>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Holidays Added"
            onAdd={() => { setEH(null); setFH({ name:'', start_date:'', end_date:'', location_id:'', note:'' }); setMH(true); }}
          />
        </div>
      )}

      {activeTab === 'departments' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-building" style={{ color: '#4f46e5' }} /> Organization Departments
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search departments..." value={sD} onChange={e => setSD(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => { setEDept(null); setFDept({ name:'', department_id:'', description:'' }); setMDept(true); }}>
                <i className="fas fa-plus" /> Add Department
              </button>
            </div>
          </div>
          <Table
            h={['Department Name', 'Department ID', 'Description', 'Actions']}
            rows={departments.filter(x => !sD || (x.name||'').toLowerCase().includes(sD.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.name}</td>
                <td><span className="mfg-badge mfg-badge-purple">{x.department_id||'-'}</span></td>
                <td>{x.description||'-'}</td>
                <td>
                  <div className="mfg-actions">
                    <button className="mfg-action-btn edit" onClick={() => { setEDept(x.id); setFDept({ name: x.name||'', department_id: x.department_id||'', description: x.description||'' }); setMDept(true); }}><i className="fas fa-pen" /></button>
                    <button className="mfg-action-btn delete" onClick={() => delDept(x.id)}><i className="fas fa-trash-alt" /></button>
                  </div>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Departments Defined"
            onAdd={() => { setEDept(null); setFDept({ name:'', department_id:'', description:'' }); setMDept(true); }}
          />
        </div>
      )}

      {activeTab === 'designations' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-id-badge" style={{ color: '#4f46e5' }} /> Staff Designations
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search designations..." value={sDe} onChange={e => setSDe(e.target.value)} />
              </div>
              <button className="mfg-btn mfg-btn-primary" onClick={() => { setEDesig(null); setFDesig({ name:'', description:'' }); setMDesig(true); }}>
                <i className="fas fa-plus" /> Add Designation
              </button>
            </div>
          </div>
          <Table
            h={['Designation Title', 'Description', 'Actions']}
            rows={designations.filter(x => !sDe || (x.name||'').toLowerCase().includes(sDe.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.name}</td>
                <td>{x.description||'-'}</td>
                <td>
                  <div className="mfg-actions">
                    <button className="mfg-action-btn edit" onClick={() => { setEDesig(x.id); setFDesig({ name: x.name||'', description: x.description||'' }); setMDesig(true); }}><i className="fas fa-pen" /></button>
                    <button className="mfg-action-btn delete" onClick={() => delDesig(x.id)}><i className="fas fa-trash-alt" /></button>
                  </div>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Designations Created"
            onAdd={() => { setEDesig(null); setFDesig({ name:'', description:'' }); setMDesig(true); }}
          />
        </div>
      )}

      {activeTab === 'sales_target' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-bullseye" style={{ color: '#4f46e5' }} /> Sales Targets & Performance
          </div>
          <div className="mfg-toolbar">
            <div className="mfg-toolbar-left">
              <div className="mfg-entries-group">
                <span>Show</span>
                <select><option>25</option></select>
                <span>entries</span>
              </div>
            </div>
            <div className="mfg-toolbar-right">
              <div className="mfg-search-box">
                <i className="fas fa-search mfg-search-icon" />
                <input type="text" className="mfg-search" placeholder="Search employee..." value={sST} onChange={e => setSST(e.target.value)} />
              </div>
            </div>
          </div>
          <Table
            h={['Employee Name', 'Last Month Performance', 'This Month Performance', 'Actions']}
            rows={salesTargets.filter(x => !sST || (x.user_name||'').toLowerCase().includes(sST.toLowerCase())).map(x => (
              <tr key={x.id}>
                <td style={{ fontWeight: 600 }}>{x.user_name}</td>
                <td><span className="mfg-badge mfg-badge-primary">{x.target_achieved_last_month ?? 0}</span></td>
                <td><span className="mfg-badge mfg-badge-success">{x.target_achieved_this_month ?? 0}</span></td>
                <td>
                  <button className="mfg-btn mfg-btn-sm mfg-btn-primary"><i className="fas fa-crosshairs" /> Set Target</button>
                </td>
              </tr>
            ))}
            loading={loading}
            emptyTitle="No Sales Targets Assigned"
          />
        </div>
      )}

      {activeTab === 'settings' && (
        <div className="mfg-card">
          <div className="mfg-card-title">
            <i className="fas fa-sliders" style={{ color: '#8b5cf6' }} /> HRM Settings & Rules
          </div>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            <div style={{ width: '200px', flexShrink: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                {[{ k: 'leave', l: 'Leave Config', i: 'fas fa-calendar-alt' }, { k: 'payroll', l: 'Payroll Config', i: 'fas fa-money-bill-wave' }, { k: 'attendance', l: 'Attendance Rules', i: 'fas fa-clock' }, { k: 'sales_targets', l: 'Sales Target Rules', i: 'fas fa-bullseye' }, { k: 'essentials', l: 'Essentials Prefix', i: 'fas fa-cog' }].map(s => (
                  <button key={s.k} className={`mfg-sub-tab ${subS === s.k ? 'active' : ''}`} style={{ width: '100%', justifyContent: 'flex-start', padding: '0.65rem 0.85rem' }} onClick={() => setSubS(s.k)}>
                    <i className={s.i} style={{ marginRight: '0.4rem' }} /> {s.l}
                  </button>
                ))}
              </div>
            </div>

            <div style={{ flex: 1, minWidth: '280px', background: 'var(--etpos-bg, #f8fafc)', padding: '1.25rem', borderRadius: '12px', border: '1px solid var(--etpos-border, #e2e8f0)' }}>
              {subS === 'leave' && (
                <div>
                  <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                    <label>Leave Reference No. Prefix:</label>
                    <input className="mfg-input" value={fSet.leave_ref_no_prefix || ''} onChange={e => setFSet({...fSet, leave_ref_no_prefix: e.target.value})} placeholder="e.g. LV-" />
                  </div>
                  <div className="mfg-filter-group" style={{ marginBottom: '1.25rem' }}>
                    <label>Leave Instructions:</label>
                    <textarea className="mfg-input" rows={5} value={fSet.leave_instructions || ''} onChange={e => setFSet({...fSet, leave_instructions: e.target.value})} placeholder="Instructions shown during leave submission..." />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}><button className="mfg-btn mfg-btn-purple" onClick={svSet}><i className="fas fa-save" /> Save Settings</button></div>
                </div>
              )}

              {subS === 'payroll' && (
                <div>
                  <div className="mfg-filter-group" style={{ marginBottom: '1.25rem' }}>
                    <label>Payroll Reference No. Prefix:</label>
                    <input className="mfg-input" value={fSet.payroll_ref_no_prefix || ''} onChange={e => setFSet({...fSet, payroll_ref_no_prefix: e.target.value})} placeholder="e.g. PAY-" />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}><button className="mfg-btn mfg-btn-purple" onClick={svSet}><i className="fas fa-save" /> Save Settings</button></div>
                </div>
              )}

              {subS === 'attendance' && (
                <div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                    <div className="mfg-filter-group">
                      <label>Grace Before Check-In (mins):</label>
                      <input type="number" className="mfg-input" value={fSet.grace_before_checkin || ''} onChange={e => setFSet({...fSet, grace_before_checkin: e.target.value})} />
                    </div>
                    <div className="mfg-filter-group">
                      <label>Grace After Check-In (mins):</label>
                      <input type="number" className="mfg-input" value={fSet.grace_after_checkin || ''} onChange={e => setFSet({...fSet, grace_after_checkin: e.target.value})} />
                    </div>
                    <div className="mfg-filter-group">
                      <label>Grace Before Check-Out (mins):</label>
                      <input type="number" className="mfg-input" value={fSet.grace_before_checkout || ''} onChange={e => setFSet({...fSet, grace_before_checkout: e.target.value})} />
                    </div>
                    <div className="mfg-filter-group">
                      <label>Grace After Check-Out (mins):</label>
                      <input type="number" className="mfg-input" value={fSet.grace_after_checkout || ''} onChange={e => setFSet({...fSet, grace_after_checkout: e.target.value})} />
                    </div>
                  </div>
                  <div style={{ marginBottom: '1.25rem' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer' }}>
                      <input type="checkbox" checked={!!fSet.is_location_required} onChange={e => setFSet({...fSet, is_location_required: e.target.checked ? 1 : 0})} style={{ accentColor: '#4f46e5', width: '16px', height: '16px' }} /> Is Location Required for Attendance
                    </label>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}><button className="mfg-btn mfg-btn-purple" onClick={svSet}><i className="fas fa-save" /> Save Settings</button></div>
                </div>
              )}

              {subS === 'sales_targets' && (
                <div>
                  <div style={{ marginBottom: '1.25rem' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer' }}>
                      <input type="checkbox" checked={!!fSet.calculate_sales_target_commission_without_tax} onChange={e => setFSet({...fSet, calculate_sales_target_commission_without_tax: e.target.checked ? 1 : 0})} style={{ accentColor: '#4f46e5', width: '16px', height: '16px' }} /> Calculate Sales Target Commission Without Tax
                    </label>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}><button className="mfg-btn mfg-btn-purple" onClick={svSet}><i className="fas fa-save" /> Save Settings</button></div>
                </div>
              )}

              {subS === 'essentials' && (
                <div>
                  <div className="mfg-filter-group" style={{ marginBottom: '1.25rem' }}>
                    <label>Essentials ToDos Prefix:</label>
                    <input className="mfg-input" value={fSet.essentials_todos_prefix || ''} onChange={e => setFSet({...fSet, essentials_todos_prefix: e.target.value})} />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}><button className="mfg-btn mfg-btn-purple" onClick={svSet}><i className="fas fa-save" /> Save Settings</button></div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modals Dialogs */}
      {mH && (
        <div className="mfg-modal-overlay" onClick={() => setMH(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>{eH ? 'Edit Holiday' : 'Add Holiday'}</h3>
              <button className="mfg-modal-close" onClick={() => setMH(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Holiday Name <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" value={fH.name} onChange={e => setFH({...fH, name: e.target.value})} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="mfg-filter-group">
                  <label>Start Date <span style={{ color: '#ef4444' }}>*</span></label>
                  <input className="mfg-input" type="date" value={fH.start_date} onChange={e => setFH({...fH, start_date: e.target.value})} />
                </div>
                <div className="mfg-filter-group">
                  <label>End Date <span style={{ color: '#ef4444' }}>*</span></label>
                  <input className="mfg-input" type="date" value={fH.end_date} onChange={e => setFH({...fH, end_date: e.target.value})} />
                </div>
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Business Location</label>
                <select className="mfg-select" value={fH.location_id} onChange={e => setFH({...fH, location_id: e.target.value})}>
                  <option value="">All Locations</option>
                  {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
                </select>
              </div>
              <div className="mfg-filter-group">
                <label>Note</label>
                <textarea className="mfg-input" rows={3} value={fH.note} onChange={e => setFH({...fH, note: e.target.value})} />
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMH(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svH}><i className="fas fa-save" /> Save</button>
            </div>
          </div>
        </div>
      )}

      {mLT && (
        <div className="mfg-modal-overlay" onClick={() => setMLT(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>{eLT ? 'Edit Leave Type' : 'Add Leave Type'}</h3>
              <button className="mfg-modal-close" onClick={() => setMLT(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Leave Type <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" value={fLT.leave_type} onChange={e => setFLT({...fLT, leave_type: e.target.value})} />
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Max Leave Count</label>
                <input className="mfg-input" type="number" value={fLT.max_leave_count} onChange={e => setFLT({...fLT, max_leave_count: e.target.value})} />
              </div>
              <div className="mfg-filter-group">
                <label>Leave Count Interval</label>
                <div style={{ display: 'flex', gap: '1rem', marginTop: '0.25rem' }}>
                  {[{v:'none',l:'None'},{v:'month',l:'Per Month'},{v:'year',l:'Per Year'}].map(o => (
                    <label key={o.v} style={{ fontSize: '0.85rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.35rem' }}>
                      <input type="radio" name="lci" checked={fLT.leave_count_interval===o.v} onChange={() => setFLT({...fLT, leave_count_interval: o.v})} /> {o.l}
                    </label>
                  ))}
                </div>
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMLT(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svLT}><i className="fas fa-save" /> Save</button>
            </div>
          </div>
        </div>
      )}

      {mL && (
        <div className="mfg-modal-overlay" onClick={() => setML(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>Request Leave</h3>
              <button className="mfg-modal-close" onClick={() => setML(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Employee <span style={{ color: '#ef4444' }}>*</span></label>
                <select className="mfg-select" value={fL.user_id} onChange={e => setFL({...fL, user_id: e.target.value})}>
                  <option value="">Select Employee</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Leave Type <span style={{ color: '#ef4444' }}>*</span></label>
                <select className="mfg-select" value={fL.essentials_leave_type_id} onChange={e => setFL({...fL, essentials_leave_type_id: e.target.value})}>
                  <option value="">Select Leave Type</option>
                  {leaveTypes.map(lt => <option key={lt.id} value={lt.id}>{lt.leave_type}</option>)}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
                <div className="mfg-filter-group">
                  <label>Start Date <span style={{ color: '#ef4444' }}>*</span></label>
                  <input className="mfg-input" type="date" value={fL.start_date} onChange={e => setFL({...fL, start_date: e.target.value})} />
                </div>
                <div className="mfg-filter-group">
                  <label>End Date <span style={{ color: '#ef4444' }}>*</span></label>
                  <input className="mfg-input" type="date" value={fL.end_date} onChange={e => setFL({...fL, end_date: e.target.value})} />
                </div>
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Reason</label>
                <textarea className="mfg-input" rows={3} value={fL.reason} onChange={e => setFL({...fL, reason: e.target.value})} />
              </div>
              <div className="mfg-filter-group">
                <label>Ref No</label>
                <input className="mfg-input" value={fL.ref_no} onChange={e => setFL({...fL, ref_no: e.target.value})} />
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setML(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svL}><i className="fas fa-save" /> Submit Request</button>
            </div>
          </div>
        </div>
      )}

      {mA && (
        <div className="mfg-modal-overlay" onClick={() => setMA(false)}>
          <div className="mfg-modal" style={{ maxWidth: '950px' }} onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>Add Attendance Records</h3>
              <button className="mfg-modal-close" onClick={() => setMA(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1.25rem', maxWidth: '380px' }}>
                <label>Select Employee to Add <span style={{ color: '#ef4444' }}>*</span></label>
                <select className="mfg-select" value={selEmp} onChange={e => addEmpRow(e.target.value)}>
                  <option value="">Choose Employee</option>
                  {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
              </div>

              <div className="mfg-table-wrap">
                <table className="mfg-table">
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Clock In Time</th>
                      <th>Clock Out Time</th>
                      <th>Shift</th>
                      <th>IP Address</th>
                      <th>Clock In Note</th>
                      <th>Clock Out Note</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {attRows.length === 0 ? (
                      <tr><td colSpan={8} style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>Select an employee from the dropdown above to add an attendance entry row.</td></tr>
                    ) : (
                      attRows.map(r => (
                        <tr key={r.user_id}>
                          <td style={{ fontWeight: 600 }}>{r.user_name}</td>
                          <td><input type="datetime-local" className="mfg-input" style={{ padding: '0.35rem' }} value={r.clock_in_time} onChange={e => updateEmpRow(r.user_id, 'clock_in_time', e.target.value)} /></td>
                          <td><input type="datetime-local" className="mfg-input" style={{ padding: '0.35rem' }} value={r.clock_out_time} onChange={e => updateEmpRow(r.user_id, 'clock_out_time', e.target.value)} /></td>
                          <td>
                            <select className="mfg-select" style={{ padding: '0.35rem' }} value={r.essentials_shift_id} onChange={e => updateEmpRow(r.user_id, 'essentials_shift_id', e.target.value)}>
                              <option value="">Shift</option>
                              {shifts.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                            </select>
                          </td>
                          <td><input type="text" className="mfg-input" style={{ padding: '0.35rem' }} placeholder="IP" value={r.ip_address} onChange={e => updateEmpRow(r.user_id, 'ip_address', e.target.value)} /></td>
                          <td><textarea className="mfg-input" rows={1} style={{ padding: '0.35rem' }} placeholder="Note" value={r.clock_in_note} onChange={e => updateEmpRow(r.user_id, 'clock_in_note', e.target.value)} /></td>
                          <td><textarea className="mfg-input" rows={1} style={{ padding: '0.35rem' }} placeholder="Note" value={r.clock_out_note} onChange={e => updateEmpRow(r.user_id, 'clock_out_note', e.target.value)} /></td>
                          <td><button className="mfg-action-btn delete" onClick={() => rmEmpRow(r.user_id)}><i className="fas fa-times" /></button></td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMA(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svAtt}><i className="fas fa-save" /> Save Attendance</button>
            </div>
          </div>
        </div>
      )}

      {mP && (
        <div className="mfg-modal-overlay" onClick={() => setMP(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>{eP ? 'Edit Payroll Group' : 'Add Payroll Group'}</h3>
              <button className="mfg-modal-close" onClick={() => setMP(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Payroll Name <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" placeholder="e.g. July 2026 Payroll" value={fP.name} onChange={e => setFP({...fP, name: e.target.value})} />
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Location <span style={{ color: '#ef4444' }}>*</span></label>
                <select className="mfg-select" value={fP.location_id} onChange={e => setFP({...fP, location_id: e.target.value})}>
                  <option value="">Select Location</option>
                  {locations.map(loc => <option key={loc.id} value={loc.id}>{loc.name}</option>)}
                </select>
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Gross Total Amount <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" type="number" step="0.01" placeholder="0.00" value={fP.gross_total} onChange={e => setFP({...fP, gross_total: e.target.value})} />
              </div>
              <div className="mfg-filter-group">
                <label>Status <span style={{ color: '#ef4444' }}>*</span></label>
                <select className="mfg-select" value={fP.status} onChange={e => setFP({...fP, status: e.target.value})}>
                  <option value="final">Final</option>
                  <option value="draft">Draft</option>
                </select>
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMP(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svP}><i className="fas fa-save" /> Save</button>
            </div>
          </div>
        </div>
      )}

      {viewP && (
        <div className="mfg-modal-overlay" onClick={() => setViewP(null)}>
          <div className="mfg-modal" style={{ maxWidth: '580px' }} onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>Payroll Details</h3>
              <button className="mfg-modal-close" onClick={() => setViewP(null)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', background: 'var(--etpos-bg, #f8fafc)', padding: '1rem', borderRadius: '10px' }}>
                <div><strong>Name:</strong> {viewP.name || '-'}</div>
                <div><strong>Added By:</strong> {viewP.added_by || '-'}</div>
                <div><strong>Location:</strong> {viewP.location_name || '-'}</div>
                <div><strong>Gross Total:</strong> <span style={{ color: '#10b981', fontWeight: 700 }}>{viewP.gross_total || '0.00'}</span></div>
                <div><strong>Payment Status:</strong> {badge(viewP.payment_status || 'due')}</div>
                <div><strong>Status:</strong> {badge(viewP.status || 'pending')}</div>
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn mfg-btn-primary" onClick={() => setViewP(null)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {mDept && (
        <div className="mfg-modal-overlay" onClick={() => setMDept(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>{eDept ? 'Edit Department' : 'Add Department'}</h3>
              <button className="mfg-modal-close" onClick={() => setMDept(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Department Name <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" placeholder="e.g. Sales" value={fDept.name} onChange={e => setFDept({...fDept, name: e.target.value})} />
              </div>
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Department ID</label>
                <input className="mfg-input" placeholder="e.g. DEP001" value={fDept.department_id} onChange={e => setFDept({...fDept, department_id: e.target.value})} />
              </div>
              <div className="mfg-filter-group">
                <label>Description</label>
                <textarea className="mfg-input" rows={3} value={fDept.description} onChange={e => setFDept({...fDept, description: e.target.value})} />
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMDept(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svDept}><i className="fas fa-save" /> Save</button>
            </div>
          </div>
        </div>
      )}

      {mDesig && (
        <div className="mfg-modal-overlay" onClick={() => setMDesig(false)}>
          <div className="mfg-modal" onClick={e => e.stopPropagation()}>
            <div className="mfg-modal-header">
              <h3>{eDesig ? 'Edit Designation' : 'Add Designation'}</h3>
              <button className="mfg-modal-close" onClick={() => setMDesig(false)}><i className="fas fa-times" /></button>
            </div>
            <div className="mfg-modal-body">
              <div className="mfg-filter-group" style={{ marginBottom: '1rem' }}>
                <label>Designation Name <span style={{ color: '#ef4444' }}>*</span></label>
                <input className="mfg-input" placeholder="e.g. Manager" value={fDesig.name} onChange={e => setFDesig({...fDesig, name: e.target.value})} />
              </div>
              <div className="mfg-filter-group">
                <label>Description</label>
                <textarea className="mfg-input" rows={3} value={fDesig.description} onChange={e => setFDesig({...fDesig, description: e.target.value})} />
              </div>
            </div>
            <div className="mfg-modal-footer">
              <button className="mfg-btn" onClick={() => setMDesig(false)}><i className="fas fa-times" /> Cancel</button>
              <button className="mfg-btn mfg-btn-primary" onClick={svDesig}><i className="fas fa-save" /> Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HRM;
